module.exports = {
  productSettings: {
    excludeFromQuote: 'Niet mee in offerte opnemen',
    properties: 'Eigenschappen',
    options: 'Opties',
    componentTypes: {
      chimney: {
        diameters: 'Diameters',
      },
    },
  },

  commentMode: 'Klik ergens op het scherm om een nieuwe opmerking toe te voegen',
  comment: {
    insertPlaceholder: 'Voeg opmerking toe',
  },

  productList: {
    noProductAvailable: 'Geen producten beschikbaar',
  },

  productTypes: {
    solarKit: {
      piping10: 'Leidingwerk 10 meter',
      piping15: 'Leidingwerk 15 meter',
    },
  },

  chimneyTitle: 'Schoorsteen - {layout}',

  categories: {
    chimney: {
      this: 'deze schoorsteen',
    },
  },


  addProductModal: {
    title: 'Product toevoegen',
    categories: {
      controllers: 'Regelingen',
      hydraulics: 'Hydraulica',
      chimneys: 'Schoorsteen',
      heatPumps: 'Warmtepompen',
      solarSystems: 'Zonnesystemen',
      kettle: 'Ketels',
      boiler: 'Boilers',
    },
    categoryTitles: {
      controllers: 'Regelingen toevoegen',
      hydraulics: 'Hydraulica toevoegen',
      chimneys: 'Schoorsteen toevoegen',
      heatPumps: 'Warmtepomp toevoegen',
      solarsystem: 'Zonnesysteem toevoegen',
      kettle: 'Ketel toevoegen',
      boiler: 'Boiler toevoegen',
    },
  },
  replaceProductModal: {
    title: 'Vervang {product}',
  },

  removeProduct: {
    warning: {
      title: 'Verwijder {product}',
      text: 'Bent u zeker dat u {product} wil verwijderen uit dit systeem?',
    },
  },

  intro: 'Klik op desbetreffend product om de bijbehorende<br/> accessoires te kunnen selecteren',
  footer: 'Dit is een presentatie van het type van het systeem, dit is op geen enkele manier een technisch schema en houdt geen rekening met eventuele beveiligingen.',
  nextLink: 'Volgende',
};



// WEBPACK FOOTER //
// ./js/lang/nl/configurator.js